module.exports = __webpack_public_path__ + "static/img/5.0d0b9173.png";